<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title> {{ 'PAGES.CREATE_FROM_TEMPLATES.TEMPLATES_MANAGE.TITLE' | translate }} </glxy-page-title>
    <glxy-page-actions>
      @if (withinTemplateLimit$ | async) {
        <button mat-flat-button color="primary" (click)="addNew()">
          <mat-icon>add</mat-icon>
          {{ 'PAGES.CREATE_FROM_TEMPLATES.TEMPLATES_MANAGE.ADD_NEW' | translate }}
        </button>
      }
      <a class="toolbar-help-icon" mat-icon-button target="_blank" href="https://websitepro.zendesk.com/hc/en-us">
        <mat-icon>help_outline</mat-icon>
      </a>
    </glxy-page-actions>
  </glxy-page-toolbar>

  <glxy-page-wrapper>
    <div class="info">
      <p>
        {{ 'PAGES.CREATE_FROM_TEMPLATES.TEMPLATES_MANAGE.SUBTITLE' | translate: { maxTemplates: maxTemplates } }}
      </p>
    </div>
    <div class="page main col{{ columns }}">
      @if ((loading$ | async) === false) {
        <div>
          @if (templatesAll$ | async; as allTemplates) {
            @if (allTemplates.length === 0) {
              <ng-container *ngTemplateOutlet="noTemplates"></ng-container>
            }
            <!-- Distributed Templates Section -->
            @if (distributedTemplates$ | async; as distributedTemplates) {
              <ng-container
                *ngTemplateOutlet="
                  templateSection;
                  context: {
                    templates: distributedTemplates,
                    titleKey: 'PAGES.CREATE_FROM_TEMPLATES.TEMPLATES_MANAGE.DISTRIBUTED_TEMPLATES',
                    allTemplatesCount: allTemplates.length,
                  }
                "
              ></ng-container>
            }
            <!-- Non-Distributed Templates Section -->
            @if (nonDistributedTemplates$ | async; as nonDistributedTemplates) {
              <ng-container
                *ngTemplateOutlet="
                  templateSection;
                  context: {
                    templates: nonDistributedTemplates,
                    titleKey: 'PAGES.CREATE_FROM_TEMPLATES.TEMPLATES_MANAGE.NON_DISTRIBUTED_TEMPLATES',
                    allTemplatesCount: allTemplates.length,
                  }
                "
              ></ng-container>
            }
          }
        </div>
      } @else {
        <mat-grid-list [cols]="columns" [rowHeight]="rowHeight" (window:resize)="onResize($event)">
          @for (i of [1, 2, 3]; track i) {
            <mat-grid-tile>
              <mat-card appearance="outlined">
                <mat-card-header>
                  <mat-card-title>
                    <div class="stencil-line-large stencil-shimmer"></div>
                  </mat-card-title>
                </mat-card-header>
                <div>
                  <mat-spinner class="info-spinner" color="accent" [diameter]="60" [strokeWidth]="8"></mat-spinner>
                </div>
              </mat-card>
            </mat-grid-tile>
          }
        </mat-grid-list>
      }
    </div>
  </glxy-page-wrapper>
</glxy-page>

<ng-template #noTemplates>
  <app-no-templates></app-no-templates>
</ng-template>

<ng-template
  #templateSection
  let-templates="templates"
  let-titleKey="titleKey"
  let-allTemplatesCount="allTemplatesCount"
>
  @if (templates.length > 0) {
    @if (titleKey) {
      <h2 class="section-title">{{ titleKey | translate }}</h2>
    }
    <mat-grid-list [cols]="columns" [rowHeight]="rowHeight" (window:resize)="onResize($event)">
      @for (template of templates; track template.siteId) {
        <mat-grid-tile>
          <app-template-card
            [template]="template"
            [templateCreatingIds]="templateCreatingIds$ | async"
            [partnerId]="partnerId"
            [canEdit]="true"
            [canDelete]="true"
            [isLessMaxTemplates]="allTemplatesCount < maxTemplates"
            (isDeleted)="deleteTemplateFromList($event, template)"
            (duplicateTemplateButtonClicked)="duplicateTemplate($event)"
            (templateId)="getParentTemplateID($event)"
          ></app-template-card>
        </mat-grid-tile>
      }
    </mat-grid-list>
  }
</ng-template>
